module.exports = __webpack_public_path__ + "static/5-1-b6acea0f7ef05d16db63eead317a7a3e.png";